const contactForm = document.querySelector('.contact__formulaire');
const contactDeco = document.querySelector('.contact__deco');

const setDecoSize = () => {
  contactDeco.style.top = `${contactForm.offsetTop}px`;
};

setDecoSize();

window.addEventListener('resize', () => {
  setDecoSize();
});
